import { GET_API_KEYS } from "../constants/constant";

export function getApiKeysList(data) {
    return {
        type: GET_API_KEYS,
        payload: data
    }
}
